export const urls = {
  setFinancialProfile: () => `/api/v1/pro/financial-profile`,
};
